import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CompletionTool from './CompletionTool.jsx';

function Layout({ title, prefill, onComplete }) {
	const [summary, setSummary] = useState('');
	const [config, setConfig] = useState({});

	return (
		<div>
			<CompletionTool config={config} prefill={prefill} onChange={(text) => setSummary(text)} />
		</div>
	);
}

Layout.defaultProps = {
	prefill: [],
	buttonText: 'AI Verktyg',
	title: 'AI Verktyg',
};

Layout.propTypes = {
	prefill: PropTypes.array,
	buttonText: PropTypes.string,
	title: PropTypes.string,
};

export { Layout, Layout as AiLayout, Layout as default };



// WEBPACK FOOTER //
// ./src/components/ai/Layout.jsx